import { render, staticRenderFns } from "./RRSP.vue?vue&type=template&id=565f9ffc"
import script from "./RRSP.vue?vue&type=script&lang=js"
export * from "./RRSP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports